export default __webpack_public_path__ + "static/media/avinash-rajak.352d66bd.jpg";